import GhostContentAPI from '@tryghost/content-api';
import React, { useEffect, useState } from 'preact/compat';

import { renderComponent } from '../Utils';
import { normalizeUrl } from '../Insights/utils';

import propTypes from './propTypes';
import './style.scss';

const getTimeDifference = dateString => {
  const publishDate = new Date(dateString);
  const today = new Date();

  const diffTime = Math.abs(today.getTime() - publishDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return `${diffDays} days ago`;
};

const Post = ({ data }) => {
  const url = data.url.replace(/cms/, 'blog');

  return (
    <div className="blog-post">
      <a href={url}>
        <img src={data.feature_image} alt="" className="mb-small" />
      </a>
      <p className="h4 mb-small">
        <a href={url}>{data.title}</a>
      </p>
      <p className="mb-small excerpt">{data.excerpt}</p>
      <div className="meta-info">
        <img
          className="author-photo"
          src={normalizeUrl(data.primary_author.profile_image)}
          alt={data.primary_author.name}
        />
        <div>
          <div className="author-name">{data.primary_author.name}</div>
          <div className="published-at">
            {getTimeDifference(data.published_at)}
          </div>
        </div>
      </div>
    </div>
  );
};

Post.propTypes = propTypes;

const fetchPosts = async () => {
  const api = GhostContentAPI({
    url: 'https://www.lbstudio.sk/cms',
    key: 'f90108e779840142be2abac936',
    version: 'v2',
  });

  let posts = [];

  try {
    posts = await api.posts.browse({ limit: 1, include: 'authors' });
  } catch (e) {
    /* pass */
  }

  return posts;
};

const BlogPreview = () => {
  const [posts, setPosts] = useState([]);

  useEffect(async () => {
    setPosts(await fetchPosts());
  }, []);

  return posts.map(post => <Post key={post.uuid} data={post} />);
};

export default renderComponent(BlogPreview, '#blog-preview');



// WEBPACK FOOTER //
// ./src/scripts/modules/BlogPreview/index.js